
import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import Editor from "@/components/editor/classic-editor.vue";
import Editor5 from "@/components/editor/classic-editor5.vue";
import { NumberToChinese } from "@/lib/util/number";
import {
  EnumQuestionType,
  Option,
  QuestionCustom,
  QuestionV2,
  QuestionV2Object
} from "@/lib/model/exambuilder/question-v2";
import { Checkpoint, ScoreRoleMap } from "@/lib/model/exambuilder/score-role";
import { Dimension } from "../../../lib/dimension/dimension";
import DimensionSelect from "../components/dimension-select.vue";
import Mp3Upload from "../components/mp3-upload.vue";
import { DimensionObject } from "@/lib/model/exambuilder/dimension-v2";
import { ExamV2Custom } from "@/lib/model/exambuilder/exam-v2";
import request from "@/lib/request/request";
import PositionList, { PositionIndustryList } from "@/lib/position/position";
import _ from "lodash-es";
import Loading from "@/components/loading.vue";
import AppendBox from "./append-box.vue";
import BlankQuestion from "./blank-question.vue";
import { BlankQuestionAnswer } from "@/lib/model/exam/candidate-answer";

@Component({
  components: {
    DimensionSelect,
    Mp3Upload,
    Editor,
    Editor5,
    Loading,
    AppendBox,
    BlankQuestion
  }
})
export default class QuestionEdit extends Vue {
  @Prop({ type: QuestionV2, default: null }) question!: QuestionV2; //题目model
  @Prop({ type: ExamV2Custom, default: null }) exam!: ExamV2Custom; //考试Model
  @Prop({ type: String, default: null }) fromDimension!: string | null; //入口维度
  @Prop({ type: Boolean, default: true }) canEditIndustryPosition!: boolean; //是否可修改行业岗位
  @Prop({ type: Number, default: 0 }) industryId!: number;
  @Prop({ type: Number, default: 0 }) positionId!: number;
  @Prop({ type: Number, default: 0 }) outFilterQuestionType!: number; //父级筛选的题型
  @Prop({ type: Boolean, default: false }) addExamQuery!: boolean; // 面试流程中查询维度和题目需要添加参数

  get setWeb(): boolean {
    return this.$route?.query?.teamUse === "setWeb";
  }

  //填空数量 、题干校验
  @Watch("questionCustomStruct.desc", {
    //题干
    immediate: true,
    deep: true
  })
  getBlankNum(newData: any, oldData: any) {
    if (this.questionCustomStruct.questionType === 5) {
      //阻止中文括号报错
      // eslint-disable-next-line no-useless-escape
      const reg = /\(\)|\（\）/g;
      const blankNum = this.questionCustomStruct.desc.match(reg)?.length || 0; //括号对数
      const answer = this.questionCustomStruct.blankQuestionConfig.answerList;
      while (answer.length !== blankNum) {
        if (answer.length < blankNum) {
          answer.push(new BlankQuestionAnswer());
        } else {
          answer.pop();
        }
      }
    }
  }

  type = 0; //题型 冗余
  questionCustomStruct = new QuestionCustom();
  currentTabIndex = 0;
  show = true;
  dimensionList: Dimension[] = []; //已选维度全字段  冗余备用
  dimensionMap = {};
  disabledDimList: string[] = []; //禁用维度
  // 这个结构是为了解决Vue数据层级太深的问题
  checkpointListMap = {};
  dataLoaded = false;
  scoreType = 0; // 打分类型
  scoreDescText =
    "评分规则：沟通表达、形象素质为默认评分规则，无需设置；其他维度可自定义设置得分点及权重；AI会根据评分规则自动对候选人进行评估；\n" +
    "权重：指得分点占此维度的权重；比如在分数配置环节对该题此维度的考察分数设置为10分，得分点权重配置为50%时，候选人命中此得分点则得5分；\n" +
    "维度本身分数需在【创建面试-分数配置】环节进行配置；";

  //不可配置规则的维度
  noRoleDimensionMap = {
    沟通表达: "系统会根据候选人表达语义、语速等自动评估",
    形象素质: "系统会根据候选人形象、面部特征等自动评估",
    普通话: "系统会根据候选人普通话水平自动评估",
    英语: "系统会根据候选人英语水平自动评估"
  };

  deleteDimIndex = 0;
  showDel = false;
  isEdit = false;
  isAutoAdding = false; // 正在自动生成得分点
  positionMap = new PositionIndustryList();
  //题型type转tab序号
  getTabIndexFormQuestionType(type: number) {
    //选择题7 音频题8 填空题5 兜底视频题0
    const ob = { 7: 1, 8: 2, 5: 3 };
    return ob[type] || 0;
  }

  async created() {
    await this.initData();
    this.initTab();
  }
  initTab() {
    this.changeQuestionType(
      this.getTabIndexFormQuestionType(this.outFilterQuestionType)
    );
  }

  changeQuestionType(typeIndex: number) {
    if (typeIndex == this.currentTabIndex) return;
    this.initNewQuestionData();
    switch (typeIndex) {
      case 0:
        this.questionCustomStruct.questionType =
          EnumQuestionType.EnumQuestionTypeVideo;
        this.initScoreRoleList();
        this.disabledDimList = [];
        break;
      case 1:
        this.questionCustomStruct.questionType =
          EnumQuestionType.EnumQuestionTypeNewSingleChoice;
        this.disabledDimList = [];
        break;
      case 2:
        this.questionCustomStruct.questionType =
          EnumQuestionType.EnumQuestionTypeMP3;
        this.initScoreRoleList();
        this.disabledDimList = ["形象素质"];
        break;
      //填空
      case 3:
        this.questionCustomStruct.questionType =
          EnumQuestionType.EnumQuestionTypeBlanks;
        this.initScoreRoleList();
        // this.disabledDimList = ["形象素质"];
        break;
    }

    this.currentTabIndex = typeIndex;
    this.$forceUpdate();
  }

  dimensionCanChange() {
    return (
      !this.question ||
      (!this.question.isExamUsed && !this.question.isSystemQuestion)
    );
  }

  descCanChange() {
    return !this.question || !this.question.isSystemQuestion;
  }

  get isSystemQuestion() {
    return this.question && this.question.isSystemQuestion === 1;
  }
  @Watch("questionCustomStruct.dimensionKeyList", {
    immediate: true,
    deep: true
  })
  aaa(a: any, b: any) {
    // debugger
  }
  async initData() {
    // this.getPosition(); //获取行业岗位
    this.questionCustomStruct.questionType =
      EnumQuestionType.EnumQuestionTypeVideo;

    const params: any = {};
    if (this.addExamQuery) {
      params.isExamEnv = 1; // 历史面试数据兼容需求，写死1
      params.withExamId = this.exam.examId; // 历史面试数据兼容需求，传面试id
    }

    const qo = await DimensionObject.get(params);
    for (const dim of qo.list) {
      this.dimensionMap[dim.dimensionKey] = dim;
    }
    if (!this.question) {
      // 创建题目
      this.initNewQuestionData();
      this.isEdit = false;
    } else {
      // 编辑题目
      this.currentTabIndex = this.getTabIndexFormQuestionType(
        this.outFilterQuestionType
      );
      this.questionCustomStruct.assign(this.question);
      const b = this.questionCustomStruct;
      // debugger;
      // assign出来的optionList没监听
      const optionList = [];
      for (const option of this.questionCustomStruct.optionList) {
        optionList.push(option);
      }
      this.questionCustomStruct.optionList = optionList;
      this.isEdit = true;
      console.log(this.question);
    }
    this.initScoreRoleList();
    this.dataLoaded = true;

    // 判断评分规则属于哪种
    try {
      if (this.questionCustomStruct.scoreRuleList.length > 0) {
        //取出非无得分点的维度
        const dim = this.questionCustomStruct.scoreRuleList.find((d, i) => {
          return !this.dontNeedPoint(d);
        });
        if (!dim) {
          //全是无得分点的维度  此时应该不展示打分规则 但需要产品确认
          this.scoreType = 1;
        } else {
          if (dim.scoreRule.aiType == 2) {
            this.scoreType = 1;
          } else if (
            dim.scoreRule.aiType == 0 &&
            dim.scoreRule.checkpointList[0].keyWordList.length > 0
          ) {
            this.scoreType = 2;
          } else {
            this.scoreType = 0;
          }
        }
      }
    } catch (e) {
      console.log(e);
    }
  }
  getPosition() {
    PositionList.get().then(res => {
      this.positionMap = res;
    });
  }

  initNewQuestionData() {
    this.questionCustomStruct.dimensionKeyList = [];
    this.questionCustomStruct.optionList = [];
    this.questionCustomStruct.scoreRuleList = [];

    if (!this.canEditIndustryPosition) {
      this.questionCustomStruct.questionIndustryId = this.exam.industryId;
      this.questionCustomStruct.questionPositionId = this.exam.positionId;
    }

    if (this.fromDimension)
      this.questionCustomStruct.dimensionKeyList.push(this.fromDimension);
    while (this.questionCustomStruct.optionList.length < 4) {
      const option = new Option();
      option.defaultScorePercent = undefined;
      this.questionCustomStruct.optionList.push(option);
    }
    //
    // const questionCustomStruct = new QuestionCustom();
    // questionCustomStruct.questionType = EnumQuestionType.EnumQuestionTypeVideo;
    // questionCustomStruct.dimensionKeyList = [];
    // // questionCustomStruct.dimensionKeyList = this.questionCustomStruct.dimensionKeyList.filter((dimKey) => {
    // //   return dimKey != ""
    // // });
    // questionCustomStruct.optionList = [];
    // while (questionCustomStruct.optionList.length < 4) {
    //   const option = new Option();
    //   option.defaultScorePercent = undefined;
    //   questionCustomStruct.optionList.push(option);
    // }
    //
    // questionCustomStruct.scoreRuleList = [];
    // this.questionCustomStruct = questionCustomStruct;
    // if (this.fromDimension)
    //   this.questionCustomStruct.dimensionKeyList.push(this.fromDimension);
    // this.initScoreRoleList();
  }

  initScoreRoleList() {
    for (const dimKey of this.questionCustomStruct.dimensionKeyList) {
      let dimScoreMap = null;
      for (const scoreMap of this.questionCustomStruct.scoreRuleList) {
        if (scoreMap.dimensionKey === dimKey) {
          dimScoreMap = scoreMap;
          break;
        }
      }
      if (!dimScoreMap) {
        dimScoreMap = new ScoreRoleMap();
        dimScoreMap.dimensionKey = dimKey;
        dimScoreMap.dimensionName = this.dimensionMap[dimScoreMap.dimensionKey]
          ? this.dimensionMap[dimScoreMap.dimensionKey].dimensionName
          : "";
        dimScoreMap.scoreRule.checkpointList = [];
        this.questionCustomStruct.scoreRuleList.push(dimScoreMap);
      }
      if (Object.prototype.hasOwnProperty.call(this.noRoleDimensionMap, dimKey))
        dimScoreMap.scoreRule.checkpointList = [];

      for (const cp of dimScoreMap.scoreRule.checkpointList) {
        cp.allKeyWords = cp.keyWordList.join(",");
      }
      this.$set(
        this.checkpointListMap,
        dimKey,
        dimScoreMap.scoreRule.checkpointList
      );
    }
  }

  onDimensionChange(list: any) {
    debugger;
    this.dimensionList = list;
    this.questionCustomStruct.dimensionKeyList = [];
    for (const dim of this.dimensionList) {
      this.questionCustomStruct.dimensionKeyList.push(dim.dimensionKey);
    }
    console.log("onDimensionChange");
    this.initScoreRoleList();
  }

  onDeleteDimension(dimKey: string) {
    console.log(dimKey);
    for (let i = 0; i < this.questionCustomStruct.scoreRuleList.length; i++) {
      const roleMap = this.questionCustomStruct.scoreRuleList[i];
      if (dimKey == roleMap.dimensionKey) {
        this.deleteDimIndex = i;
        if (roleMap.scoreRule.checkpointList.length > 0) {
          this.showDel = true;
        } else {
          this.confirmDeleteDimension();
          i--;
        }
      }
    }
  }

  confirmDeleteDimension() {
    this.questionCustomStruct.scoreRuleList.splice(this.deleteDimIndex, 1);
    this.showDel = false;
  }

  cancelDeleteDimension() {
    this.questionCustomStruct.dimensionKeyList.push(
      this.questionCustomStruct.scoreRuleList[this.deleteDimIndex].dimensionKey
    );
    console.log(this.questionCustomStruct.dimensionKeyList);
    this.$set(
      this.questionCustomStruct,
      "dimensionKeyList",
      this.questionCustomStruct.dimensionKeyList
    );
    this.showDel = false;
  }

  getMaxDimensionCount() {
    if (this.questionCustomStruct.isSingleSelect()) return 1;
    else if (this.questionCustomStruct.isBlank()) return 1;
    else if (this.questionCustomStruct.isVideoQuestion()) return 7;
    else if (this.questionCustomStruct.isMP3()) return 7;
    else return 0;
  }

  onInputKeywords(cp: Checkpoint) {
    cp.allKeyWords = cp.allKeyWords.replaceAll("，", ",");
    cp.keyWordList = cp.allKeyWords.split(",");
  }

  autoAddCheckpoint(roleMap: ScoreRoleMap) {
    if (!this.questionCustomStruct.desc.length) {
      this.$message.warning("请先填写题目描述");
      return;
    }
    // 计算所有维度总得分点数量
    this.isAutoAdding = true;
    request
      .post("/aiExam/aiPlus/recommendCheckpoint", {
        dimension: roleMap.dimensionName,
        questionDesc: this.questionCustomStruct.desc,
        checkpointNumber: 5
      })
      .then(resp => {
        this.isAutoAdding = false;
        if (resp.data.code == 0) {
          let addCount = 0;
          resp.data.data.checkpointList.forEach((name: string) => {
            // 检查得分点是否已经在列表中
            let isExist = false;
            for (const cp of this.checkpointListMap[roleMap.dimensionKey]) {
              if (cp.checkpointName == name) {
                isExist = true;
                break;
              }
            }
            if (!isExist) {
              const cp = new Checkpoint();
              cp.checkpointName = name;
              cp.expand = true;
              cp.keyWordList = [];
              cp.scorePercent = 20;
              this.checkpointListMap[roleMap.dimensionKey].push(cp);
              addCount++;
            }
          });
          if (addCount == 0) {
            this.$message.info("所有建议得分点已添加至列表中，无需再次添加");
          }
          this.$forceUpdate();
        } else {
          console.log(resp.data.message);
          this.$message.error(resp.data.message);
        }
      })
      .catch(err => {
        this.$message.error(err.data.message);
        this.isAutoAdding = false;
      });
    // const cp = new Checkpoint();
    // cp.expand = true;
    // cp.keyWordList = [];
    // cp.scorePercent = 50;
    // this.checkpointListMap[roleMap.dimensionKey].push(cp);
    // this.$forceUpdate();
  }

  addCheckpoint(roleMap: ScoreRoleMap) {
    if (!this.questionCustomStruct.desc.length) {
      this.$message.warning("请先填写题目描述");
      return;
    }
    // 计算所有维度总得分点数量
    let totalCpCount = 0;
    for (const roleMap of this.questionCustomStruct.scoreRuleList) {
      totalCpCount += roleMap.scoreRule.checkpointList.length;
    }
    if (totalCpCount < 30) {
      const cp = new Checkpoint();
      cp.expand = true;
      cp.keyWordList = [];
      cp.scorePercent = 50;
      this.checkpointListMap[roleMap.dimensionKey].push(cp);
      this.$forceUpdate();
    } else {
      this.$message.error("每道题最多设置30个得分点");
    }
  }

  expandCp(cp: Checkpoint) {
    cp.expand = !cp.expand;
  }

  onChangeOption(option: Option) {
    if (option.defaultScorePercent != undefined) {
      option.showScoreErr = false;
    }
    const contentOnlyText = option.content.replace(/<.*?>/gi, "");
    if (contentOnlyText.length <= 25 && contentOnlyText.length > 0)
      option.showContentErr = false;
    else if (contentOnlyText.length > 25) {
      // 一旦输入超过字数直接就变红
      // option.showContentErr = true;
    }
  }
  deleteCp(roleMap: ScoreRoleMap, cp: Checkpoint) {
    roleMap.scoreRule.checkpointList.splice(
      roleMap.scoreRule.checkpointList.indexOf(cp),
      1
    );
  }

  getScoreInvalid(option: Option) {
    return option.defaultScorePercent !== undefined;
  }
  addOption() {
    if (this.questionCustomStruct.optionList.length < 26) {
      const option = new Option();
      option.defaultScorePercent = undefined;
      this.questionCustomStruct.optionList.push(option);
    } else {
      // this.$message({
      //   duration: 3000,
      //   message: "请至少选择一个胜任力维度",
      //   type: "error",
      //   offset: 400
      // });
    }
  }
  delOption(index: number) {
    if (this.questionCustomStruct.optionList.length == 1) {
      this.$message({
        duration: 2000,
        message: "请至少输入一个选项",
        type: "error",
        offset: 200
      });
      return;
    }

    this.questionCustomStruct.optionList.splice(index, 1);
    console.log(this.questionCustomStruct.optionList);
  }
  //离开前数据校验
  checkData() {
    let checkResult = true;
    //表单
    if (this.questionCustomStruct.desc == "") {
      this.$message({
        duration: 2000,
        message: "请填写题目描述",
        type: "error"
        // offset: 150
      });
      checkResult = false;
      return checkResult;
    }
    // 检查题干长度
    // const contentOnlyText = this.questionCustomStruct.desc.replace(
    //   /<.*?>/gi,
    //   ""
    // );
    // if (contentOnlyText.length > 1000) {
    //   checkResult = false;
    //   this.$message({
    //     duration: 2000,
    //     message: "题目描述不可超过1000字",
    //     type: "error"
    //     // offset: 400
    //   });
    //   return checkResult;
    // }

    //未选维度
    if (this.exam && this.questionCustomStruct.dimensionKeyList.length > 0) {
      let hasExamKey = false;
      for (const examKey of this.exam.dimensionKeyList) {
        if (this.questionCustomStruct.dimensionKeyList.indexOf(examKey) >= 0) {
          hasExamKey = true;
          break;
        }
      }

      if (!hasExamKey) {
        checkResult = false;
        this.$message({
          duration: 6000,
          message:
            "所选维度本场面试未考察，请至少选择一个本场面试考察的胜任力维度",
          type: "error",
          offset: 400
        });
        return checkResult;
      }
    } else {
      if (!this.questionCustomStruct.dimensionKeyList.length) {
        (this.$refs.select as any)?.checkData();
        this.$message({
          duration: 2000,
          message: "请至少选择一个胜任力维度",
          type: "error",
          offset: 200
        });
        checkResult = false;
        return checkResult;
      }
    }

    if (this.questionCustomStruct.isSingleSelect()) {
      let has100Option = false;
      let undefindOptionNum = 0;
      for (let i = 0; i < this.questionCustomStruct.optionList.length; i++) {
        const option = this.questionCustomStruct.optionList[i];
        if (option.defaultScorePercent == 100) has100Option = true;

        // 检查是否为空
        if (option.content == "" || option.defaultScorePercent == undefined) {
          // 如果同时为空，则可以去掉
          if (option.content == "" && option.defaultScorePercent == undefined) {
            undefindOptionNum++;
            if (this.questionCustomStruct.optionList.length > 1) {
              // this.questionCustomStruct.optionList.splice(i, 1);
              // i--;
              // continue;
            } else {
              // option.showContentErr = true;
              // option.showScoreErr = true;
              // this.$message({
              //   duration: 3000,
              //   message: "请至少输入一个选项",
              //   type: "error",
              //   offset: 400,
              // });
              // checkResult = false;
              // return checkResult;
            }
          } else {
            if (option.content == "") option.showContentErr = true;
            if (option.defaultScorePercent == undefined)
              option.showScoreErr = true;
            checkResult = false;
          }
        }
        // 检查选项长度
        const contentOnlyText = option.content.replace(/<.*?>/gi, "");
        if (contentOnlyText.length > 25) {
          // option.showContentErr = true;
          // checkResult = false;
          // this.$message({
          //   duration: 2000,
          //   message: "选项字数不可超过25字",
          //   type: "error",
          //   offset: 200
          // });
          return checkResult;
        }
      }
      //选项全为空
      if (undefindOptionNum === this.questionCustomStruct.optionList.length) {
        this.$message({
          duration: 2000,
          message: "请至少输入一个选项",
          type: "error",
          offset: 200
        });
        checkResult = false;
        return checkResult;
      }

      if (!has100Option) {
        checkResult = false;
        this.$message({
          duration: 2000,
          message: "请保证至少一个选项的权重为100%",
          type: "error",
          offset: 200
        });
      }
    } else {
      for (const role of this.questionCustomStruct.scoreRuleList) {
        if (this.dontNeedPoint(role)) {
          continue;
        } else if (
          role.scoreRule.checkpointList &&
          role.scoreRule.checkpointList.length > 0
        ) {
          //配置隐藏了 无需校验  先注掉
          // for (let i = 0; i < role.scoreRule.checkpointList.length; i++) {
          //   const checkpoint = role.scoreRule.checkpointList[i];
          //   console.log(checkpoint);
          //   if (
          //     checkpoint.checkpointName == "" ||
          //     (checkpoint.allKeyWords == "" && this.scoreType == 2)
          //   ) {
          //     checkpoint.showErr = true;
          //     checkResult = false;
          //     this.$message({
          //       duration: 2000,
          //       message: "该题目有得分点未配置",
          //       type: "error",
          //       offset: 200
          //     });
          //     return checkResult;
          //   }
          // }
        }
      }
    }

    //得分配置隐藏了， 先注掉
    // switch (this.scoreType) {
    //   case 0:
    //     break;
    //   case 1:
    //     for (const role of this.questionCustomStruct.scoreRuleList) {
    //       //无需得分点的维度
    //       if (this.dontNeedPoint(role)) {
    //         continue;
    //       } else if (role.scoreRule.checkpointList.length == 0) {
    //         checkResult = false;
    //         this.$message({
    //           duration: 2000,
    //           message: "每个维度请至少输入一个得分点",
    //           type: "error",
    //           offset: 200,
    //         });
    //         return checkResult;
    //       }
    //     }

    //     break;
    //   case 2:
    //     for (const role of this.questionCustomStruct.scoreRuleList) {
    //       if (role.scoreRule.aiType == 0) {
    //         //无需得分点的维度
    //         if (this.dontNeedPoint(role)) {
    //           continue;
    //         } else if (role.scoreRule.checkpointList.length == 0) {
    //           checkResult = false;
    //           this.$message({
    //             duration: 2000,
    //             message: "每个维度请至少输入一个得分点",
    //             type: "error",
    //             offset: 200,
    //           });
    //           return checkResult;
    //         }
    //       }
    //     }
    //     break;
    // }

    // 计算所有维度总得分点数量
    let totalCpCount = 0;
    for (const roleMap of this.questionCustomStruct.scoreRuleList) {
      totalCpCount += roleMap.scoreRule.checkpointList.length;
    }
    if (totalCpCount > 30) {
      this.$message.error("题目最多可设置30个得分点，请删除后再保存");
      checkResult = false;
    }
    return checkResult;
  }
  //无需得分点的维度key
  dimKeyWithOutPoint = ["沟通表达", "形象素质", "普通话", "英语"];
  dontNeedPoint(role: any) {
    return this.dimKeyWithOutPoint.includes(role.dimensionKey);
  }

  @Emit()
  change() {
    return this.question.questionId;
  }

  confirm() {
    if (!this.checkData()) return;
    // 保证在富文本在点选打字不触发change时手动触发，富文本内有节流函数，设置500ms延迟
    setTimeout(async () => {
      try {
        // 给每个维度配置评分规则是关键词还是AI模型判断
        for (const rule of this.questionCustomStruct.scoreRuleList) {
          switch (this.scoreType) {
            case 0:
              rule.scoreRule.aiType = 0;
              break;
            case 1:
              rule.scoreRule.aiType = 2;
              break;
            case 2:
              rule.scoreRule.aiType = 0;
              break;
          }
        }

        // 把无用的数据从提交数据里清除
        // 非关键词判断时，清理关键词结构
        if (this.scoreType != 2) {
          for (const rule of this.questionCustomStruct.scoreRuleList) {
            for (const checkPoint of rule.scoreRule.checkpointList) {
              checkPoint.keyWordList = [];
            }
          }
        }

        // 清理选择题选项
        if (!this.questionCustomStruct.isSingleSelect()) {
          this.questionCustomStruct.optionList = [];
        } else {
          this.questionCustomStruct.scoreRuleList = [];
          //单选 删除为空的选项
          for (
            let i = 0;
            i < this.questionCustomStruct.optionList.length;
            i++
          ) {
            if (
              this.questionCustomStruct.optionList[i].content == "" &&
              this.questionCustomStruct.optionList[i].defaultScorePercent ==
                undefined
            ) {
              this.questionCustomStruct.optionList.splice(i, 1);
              i--;
            }
          }
        }
        //去掉无需得分点的维度
        for (
          let i = 0;
          i < this.questionCustomStruct.scoreRuleList.length;
          i++
        ) {
          const role = this.questionCustomStruct.scoreRuleList[i];
          //无需得分点的维度
          if (this.dontNeedPoint(role)) {
            this.questionCustomStruct.scoreRuleList.splice(i, 1);
            i--;
          }
        }

        const mp3Info = (this.$refs.mp3Upload as Mp3Upload).getMp3Info();
        for (const key in mp3Info) {
          if (Object.prototype.hasOwnProperty.call(mp3Info, key)) {
            this.questionCustomStruct[key] = mp3Info[key];
          }
        }

        // 提交数据
        if (this.question && this.question.questionId)
          await QuestionV2Object.update(
            this.question.questionId,
            this.questionCustomStruct
          );
        else await QuestionV2Object.create(this.questionCustomStruct);
        this.close(true);
      } catch (e) {
        console.log(e);
        //this.$message.error("网络错误，请重试");
      }
    }, 500);
  }
  //关闭
  close(saveChange = false) {
    this.show = false;
    this.$emit("close", saveChange);
  }

  numberToChinese(number: number) {
    return NumberToChinese(number);
  }
}
